/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2025-09-17 11:26:21
 * @LastEditors: yuhaiyang yuhaiyangz@163.com
 * @LastEditTime: 2026-02-03 17:36:47
 * @FilePath: \ccxd_app_react_mobile\src\api\loadingManager.ts
 * @Description: 全局Loading状态管理
 */
import { Toast } from 'antd-mobile'
// @ts-ignore
window.Toast = Toast;


class LoadingManager {
  
    private loadingCount: number = 0;
    private loadingInstance: any = null;
    // 显示Loading的方法 - 需要根据实际UI框架实现
    private showLoading() {
      // 这里以Element Plus为例，实际使用时请替换为您的UI框架的Loading方法
      if (typeof window !== 'undefined' && (window as any).Toast) {
        this.loadingInstance = (window as any).Toast.show({icon: 'loading',content: '加载中…',duration:0});
        console.log(this.loadingInstance);
      } else {
        console.log('显示加载中...');
      }
    }
    
    // 隐藏Loading的方法
    private hideLoading() {
      if (this.loadingInstance) {
        setTimeout(()=>{
          this.loadingInstance?.close();
          this.loadingInstance = null;
          console.log('aa,我关闭了',this.loadingInstance);
        },500)
        setTimeout(()=>{
          Toast.clear()
        },2000)
       
        
      }
    }
    
    // 增加Loading计数
    addLoading() {
      this.loadingCount++;
      if (this.loadingCount === 1) {
        this.showLoading();
      }
    }
    
    // 减少Loading计数
    removeLoading() {
      this.loadingCount--;
      if (this.loadingCount <= 0) {
        this.loadingCount = 0;
        this.hideLoading();
      }
    }
    
    // 重置Loading计数
    resetLoading() {
      this.loadingCount = 0;
      this.hideLoading();
    }
  }
  // 创建全局Loading管理器实例
export const loadingManager = new LoadingManager();